import { render, staticRenderFns } from "./LeavePageStatisticsList.vue?vue&type=template&id=2bc7cb12&scoped=true&"
import script from "./LeavePageStatisticsList.vue?vue&type=script&lang=js&"
export * from "./LeavePageStatisticsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7cb12",
  null
  
)

export default component.exports